import { useContext } from 'react'
import { sessionContext } from 'providers/session'

const useSession = () => useContext(sessionContext)

export default useSession